/**
 * Implmentation of abstract functions on react-query
 *
 * @author - Harsh Tomar
 */

// Dependencies
import { useMutation, useQuery } from "react-query";
import { account, COLLECTION_IDS, database, DATABASE_ID } from "./appwrite";
import { Endpoints } from "./endpoints";
import Api from "./fetch";
import { ID, Models } from "appwrite";
import { getMyProfile } from "./requests";
import { UserResponse } from "./responses";
import { call, PATH } from "../managers/network";

const api = new Api();

export const useEmailLoginSignup = (email: string) =>
  useMutation((email: string) =>
    api.post(Endpoints.emailLoginSignup, { email })
  );

export const useExchangeAccessToken = (
  params: { loginToken: string; userId: string },
  onSuccess?: (data: Record<string, unknown>) => void
) =>
  useQuery(
    [Endpoints.exchangeAccessToken, params.loginToken],
    () =>
      api.post(Endpoints.exchangeAccessToken, {
        loginToken: params.loginToken,
      }),
    // () => account.updateMagicURLSession(params.userId, params.loginToken),
    { onSuccess }
  );

export const useGetCurrentUser = (enabled: boolean) =>
  useQuery<UserResponse>(["profile"], getMyProfile);

export const useUpdateUserName = () =>
  useMutation((name: string) =>
    // account.updateName(name)
    api.patch(Endpoints.users, { name })
  );

export const createMonitor = (params: {
  type: string;
  url: string;
  name: string;
}) => api.post(Endpoints.monitors, params);


export const useProfile =  ()=> useQuery(["profile"],()=>getMyProfile());

export const createAPing = (monitorId:string) =>
  api.post(Endpoints.createPing,{ monitorId })


export const pauseAMonitor = (monitorId:string) =>
api.patch(Endpoints.monitors,{ _id: monitorId, status: 'PAUSED' })

export const activateAMonitor = (monitorId:string) =>
api.patch(Endpoints.monitors,{ _id: monitorId, status: 'ACTIVE' })
  
export const emailLoginSignup = (params: { email: string; url?: string }) =>
  api.post(Endpoints.emailLoginSignup, params);

export const useGetLtdCustomersCount = () =>
  useQuery<{ ltdCustomersCount: number }>(["getLtdCustomesCount"], () =>
    call({ method: "GET", path: PATH.getLtdCustomersCount })
  );


export const useUpdateAlerts = () =>
  useMutation((variables: {alertTo : object})=>call({ method: "PUT", path: PATH.monitorsAlert, data: variables}))


export const useLogout = () => useMutation(()=>call({ method: "GET", path: PATH.logout}));

export const logout = () => call({ method: "GET", path: PATH.logout});

export const deleteAMonitor = (monitorId: string ) => call({ method: 'DELETE', path: PATH.monitorsId.replace('{{monitorId}}', monitorId) , data: null })